
import React, { createContext, useContext, useState, useEffect } from 'react';

interface ConstructionModeContextType {
  isConstructionMode: boolean;
  toggleConstructionMode: () => void;
}

const ConstructionModeContext = createContext<ConstructionModeContextType | undefined>(undefined);

const STORAGE_KEY = 'construction-mode';

export const ConstructionModeProvider = ({ children }: { children: React.ReactNode }) => {
  const [isConstructionMode, setIsConstructionMode] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'true') {
      setIsConstructionMode(true);
    }
  }, []);

  // Toggle is now only callable by admin users (enforced in ConstructionModeToggle component)
  // No password required - admin role check is the security gate
  const toggleConstructionMode = (): void => {
    const newMode = !isConstructionMode;
    setIsConstructionMode(newMode);
    localStorage.setItem(STORAGE_KEY, newMode.toString());
  };

  return (
    <ConstructionModeContext.Provider value={{ isConstructionMode, toggleConstructionMode }}>
      {children}
    </ConstructionModeContext.Provider>
  );
};

export const useConstructionMode = () => {
  const context = useContext(ConstructionModeContext);
  if (context === undefined) {
    throw new Error('useConstructionMode must be used within a ConstructionModeProvider');
  }
  return context;
};
